import { PointAssignment } from "../../model/point-assignment";
import { PointStats } from "../../model/point-stats";

export interface PointAssigmentTracked extends PointAssignment {
    currentPoints: number;
    places: number;
    membersOnly: boolean;
    entryCount: number;
    enableNominations: boolean;
};

export abstract class PointsUtilities {
    public static isMatchingPointAssigment(
        pointAssigment: PointAssignment, entryCost: number, 
        isSidePot: boolean, isAggregateOrAverage: boolean): boolean {
        return entryCost >= pointAssigment.entryFeeMinimum && entryCost <= pointAssigment.entryFeeMaximum
            && pointAssigment.isSidepot === isSidePot && pointAssigment.isAverageOrAggregate === isAggregateOrAverage
    }
    public static handlePointStatAssigment(
        pointAssigment: PointAssigmentTracked,
        place: number,
        runId: number,
        payoutConfigId: number,
        leaderCategory: string,
        shouldContestantOneGetPoints: boolean,
        shouldContestantTwoGetPoints: boolean,
    ): PointStats {
        const newPointStat: PointStats = {
            place: place,
            pointAssignmentId: pointAssigment.id,
            points: shouldContestantOneGetPoints ? pointAssigment.currentPoints: 0,
            pointSeriesId: pointAssigment.pointSeriesId,
            rodeoEventRunId: runId,
            bonusPointsIncluded: 0,
            leaderCategory,
            id: 0,
            payoutConfigId,
            rider2Points: shouldContestantTwoGetPoints ? pointAssigment.currentPoints : 0,
        }
        pointAssigment.currentPoints -= pointAssigment.pointDecrementPerPlace;
        return newPointStat
    }
}


// WEBPACK FOOTER //
// ./src/lib/points/PointsUtilities.ts